import { motion } from "framer-motion";
import { hobbiesData } from "../lib/ui";

export default function Hobbies() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 auto-rows-[100px]">
      {hobbiesData.map((hobby, i) => (
        <motion.div
          key={hobby.name + i}
          className={`${hobby.gridClass || ""} group relative rounded-2xl overflow-hidden bg-app-panel border border-app-border cursor-default shadow-sm transition-all duration-300 cursor-pointer hover:shadow-glow-v hover:border-app-secondary`}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: i * 0.05 }}
        >
          {/* Background Gradient Accent */}
          <div className="absolute inset-0 bg-gradient-to-br from-app-accent/5 to-app-secondary/5 opacity-50 group-hover:opacity-100 transition-opacity duration-500" />
          
          {/* Default State (Icon & Name) */}
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 p-3 transition-all duration-500 group-hover:scale-110 group-hover:opacity-0 group-hover:blur-sm">
            <span className="text-3xl filter grayscale-[50%] opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:rotate-12" role="img" aria-hidden="true">
              {hobby.icon}
            </span>
            <span className="text-[10px] sm:text-xs font-bold text-app-mute group-hover:text-app-text transition-colors uppercase tracking-wider text-center">
              {hobby.name}
            </span>
          </div>
 
          {/* Hover Reveal State (Description) */}
          <div className="absolute inset-0 flex flex-col items-center justify-center p-4 bg-app-panel/95 backdrop-blur-md opacity-0 translate-y-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
            <span className="text-2xl mb-2" role="img" aria-hidden="true">
              {hobby.icon}
            </span>
            <p className="text-[10px] sm:text-xs font-medium text-app-text text-center leading-relaxed">
              {hobby.desc}
            </p>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
